"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M16.375 28.719l2.938 2.937L6.844 44.031 2 46l2.031-4.906 12.344-12.375zm15.186 5.334h.01l.051-7.441 10.235-10.235 2.8-.03.006-.011a1.784 1.784 0 0 0 1.248-3.048l-5.6-5.6-5.6-5.6a1.784 1.784 0 0 0-3.047 1.248h-.01l-.033 2.8-10.232 10.242-7.439.054v.009a1.761 1.761 0 0 0-1.363.511 1.784 1.784 0 0 0 0 2.526l7.971 7.972 7.969 7.971a1.779 1.779 0 0 0 3.039-1.367z" })
);

